<template>
  <div class="dfAgreement">
    <div class="title"><h1>大方租车隐私政策</h1></div>
    <div class="upDataInfo">
      发布日期: 2021年09月18日<br/>
      生效日期: 2021年09月18日<br/>
      开发者名称：武汉大方汽车租赁有限公司
    </div>
    <div class="item">
      <strong>重要提示条款：<br/>
        向您说明，本次隐私政策内容增加了SDK调用说明、以及个人信息保存、披露说明修改、APP敏感权限说明修改
      </strong>
    </div>
    <div class="item">
      尊敬的大方用户，欢迎您使用大方租车!大方租车提醒您:大方租车涉及具体产品服务的,由有资质的服务商和大方租车公司提供。如果用户在本网站访问、预订或使用大方租车的产品或服务(以上统称为"<strong>服务</strong>
      ") ,便视为用户接受了以下隐私政策,<strong>请您仔细阅读以下内容,尤其是以下加粗字体</strong>,如果您有任何疑问，可联系我们客服电话<strong>（4006668818），如果不同意以下任何内容,请立刻停止访问/使用本网站或其他任何移动应用或软件</strong>
      。本隐私政策中提及 “<strong>我们</strong>"指"<strong>大方租车</strong>", "<strong>用户</strong>"以及“<strong>您</strong>”均指自愿接受本隐私政策的用户。
    </div>
    <div class="item">
      <h2>第一部分 定义</h2>
      1. <strong>大方租车</strong>：为租客提供租车服务的平台运营者和服务提供者的大方租赁股份有限公司及其指定的关联公司。<br/>
      2. <strong>大方平台</strong>：包括但不限于“大方租车”手机应用客户端等软件/网站平台等。大方租车平台将为大方租车用户（定义见下文）提供网络租车服务。<br/>
      3.<strong>大方租车用户</strong>：指按照“大方租车”的要求自愿完成有效注册的“大方租车平台”用户。大方租车用户可以通过手机应用客户端、大方租车官网、第三方提供的注册入口等填写真实信息并成为“大方租车用户”，享受“大方租车”提供的网络租车服务（以下简称为“用户”或“您”）。<br/>
      4. <strong>用户信息</strong>：指您提交给大方租车/大方租车平台的及通过大方租车/大方租车平台发布的用户相关信息，包括但不限于您提交、发布的本人信息（包括但不限于您的<strong>姓名、身份证号、身份证所载明的其他信息、照片的身份信息或其他身份证明信息、您的即时脸部图像</strong>），具体以大方租车要求为准；以及您为申请、使用大方租车及/或合作方所供的服务而提交的其他用户相关信息。<br/>
      5.<strong>个人敏感信息</strong>：指包括<strong>身份证件号码、个人生物识别信息、银行账号、财产信息、交易信息</strong>等个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。<br/>
      6. <strong>个人信息删除</strong>：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
    </div>

    <div class="item">
      <h3>第二部分 本隐私政策将帮助您了解以下内容：</h3>
      一、信息的收集和使用<br/>
      二、我们如何使用 Cookie 和同类技术<br/>
      三、我们如何储存和保存您的个人信息<br/>
      四、我们如何共享、转让、公开披露您的个人信息<br/>
      五、第三方SDK名称、手机个人信息类型、使用目的<br/>
      六、自启动和关联启动说明<br/>
      七、您的权利<br/>
      八、本政策更新<br/>
      九、如何联系我们
    </div>

    <div class="item">
      <h3>一、信息的收集和使用</h3>
      <strong>为本隐私政策之目的，个人信息包括但不限于（其中，个人敏感信息以加粗方式显示）</strong
      >：基本信息（<strong>包括个人姓名、手机号码</strong>）；个人身份信息<strong>（包括身份证、驾驶证等）；面部特征</strong>；网络身份标识信息（<strong>包括账户名</strong>）；个人财产信息（<strong>租车记录、大方信用记录等</strong>）；其他信息（<strong>大概定位信息、精准定位信息</strong>）；手机拨号（<strong>包括拨打电话号码</strong>）。<br/>
      在您使用我们的产品或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：<br/>
      <strong>1．
        为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务，我们的基本业务功能，包括注册用户服务、实现信息搜索和展示、交易及交易订单管理、客服及争议解决、ACN协同服务、保障交易安全所必须的功能；</strong><br/>
      <strong>2．
        为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。</strong><br/>
      <span>【特别提示】</span><br/>
      <strong>您理解并同意：</strong><br/>
      <strong>1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，相应地，基本/附加功能及收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；</strong><br/>
      <strong>2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过<strong>更新本隐私政策、以弹窗、页面提示</strong>等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。</strong><br/>
      在此过程中，如果您有任何疑问、意见或建议的，您可通过大方租车平台官方客服（<strong>4006668818</strong>）与我们联系，我们会尽快为您作出解答。<br/>
      为本隐私政策之目的，我们仅会出于以下核心业务功能，收集和使用您的个人信息，如果您不提供相关信息，您将无法享受我们提供的产品和/或服务。
    </div>

    <div class="item">
      <h3>（一）帮助您成为我们的注册用户</h3>
      <h4>1、 基础用户服务</h4>
      （1）我们通过大方租车平台账户为您提供基础用户服务。当您注册成为大方租车用户或登录大方租车账号时，
      您需要向大方租车提供您本人的手机号码，并准确输入大方租车以短信形式发送至您手机的验证码，且允许大方租车获取您的手机IMEI信息，开启读写存储卡权限。大方租车以此识别您在大方租车的网络身份和标识您的设备，并为您提供服务。如果您拒绝提供手机号码和验证码，或不允许大方租车获取您的手机IMEI信息，并开启读写存储卡权限，大方租车可能无法提供后续的相关拓展服务。如果您仅需使用浏览服务，您不需要注册成为我们的用户及提供上述信息。<br/>
      （2）<strong>基于我们与通信运营商的合作，当您使用 “一键登录”功能时，经过您的明示同意，运营商会将您的手机号发送给我们，便于我们为您提供快捷的登录服务。</strong>
      如果拒绝提供手机号将无法使用“一键登录”方式注册登录，但不影响您通过其他方式注册登录，也不影响其他功能的正常使用。请您注意，如果您的手机同时运行两张通信卡，我们将获取您使用移动数据流量卡的手机号码。<br/>
      （3）当需要通过大方租车平台用户账户才能使用的服务，我们可能会根据您提供的上述信息校验您的用户身份，确保我们是在为您本人提供服务。您需要根据大方租车平台提示的要求，向大方租车提供您的相关信息（包括<strong>姓名、证件号、本人真实头像照片、证件照片、面部识别特征信息</strong>）。大方租车收集上述信息，是基于法律法规要求、保护用户人身财产安全、保障交易真实、依照平台规则处理用户纠纷之需要。为进行实名认证，<strong
    >大方租车将向大方租车合作的第三方提交您的前述信息，并从合法保存有您个人信息的第三方处获得、保存有关您身份信息的验证结果，如果您拒绝提供上述信息或拒绝大方租车作前述信息分享、保存，您将无法作为大方租车实名认证用户使用大方租车服务。</strong><br/>
      （4）如果您选择使用第三方账号（如支付宝等，具体以页面实时呈现为准）登录我们的服务，<strong>我们将从该第三方获取您授权的信息（第三方用户昵称、第三方用户头像及您授权的其他信息）</strong>。使用支付宝关联登录支付宝可能会使用到您的剪切板读写与写入权限，<strong
    >这些信息仅供实现登录相关的目的所使用，不会收集您的隐私信息。</strong
    >
    </div>

    <div class="item">
      <h4>2、 附加用户服务</h4>
      <strong>实人认证</strong>：您可以根据认证要求向我们提供相应的<strong>身份信息（身份证及其他身份证件信息）、生物识别特征（静态或动态的面部特征）</strong>以完成实人认证，实人认证主要用于签订租车电子合同，<span
    >我公司不得做替他用途。</span
    ><br/>
      <strong>实名认证</strong>：您可以根据认证要求向我们提供相应的<strong>身份信息（身份证）、银行卡信息</strong>以完成实名认证，实名认证可确保您的风控信息，以便我们提供安全的服务。<br/>
      <strong>授权登录</strong>：经您授权同意后，<strong>我们可能向第三方共享您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或登录。</strong>此外，我们可能会根据您的授权从第三方处获取您的第三方账户信息，并与您的大方租车平台账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。
    </div>

    <div class="item">
      <h4>3、 账户信息展示</h4>
      如果您已拥有大方租车平台账户，我们可能会在大方租车平台服务中显示您的上述个人信息（实人认证实名认证仅显示认证是否通过的结果），以及您在大方租车平台上或与大方租车平台账户相关联的产品和服务中执行的操作，包括通过大方租车平台账户集中展示您的个人资料、优惠权益、交易订单。我们会尊重您对大方租车平台服务和大方租车平台账户设置所做的选择。
    </div>

    <div class="item">
      <h3>（二）租车服务在线交易所必需的信息：</h3>
      <strong>您使用大方租车平台服务时，大方租车将在您发送订单请求至订单完成过程中，收集您的以下信息：</strong><br/>
      1. <strong>位置信息：以便您不需要手动输入地理坐标即可获得相关的服务。</strong>在您首次使用大方租车平台前，
      大方租车会提示您选择是否允许大方租车平台获取以及何种情况下可以获取您的位置信息。在您使用大方租车平台的过程中，您可以随时通过您的设备设置功能，选择是否允许大方租车平台获取以及何种情况下可以获取您的位置信息。<strong
    >获得您的允许后，大方租车会通过<strong>IP地址、GPS以及能够提供相关信息的其他传感器（如会为大方租车提供附近设备、Wi-Fi接入点、蓝牙和基站信息）</strong>来获取您的位置信息。如果您拒绝大方租车平台获取位置信息，您将需要手动定位您的位置。</strong
    ><br/>
      2.
      <strong>订单信息：</strong
      >您通过大方租车在线上达成租车订单，大方租车将收集您填写并提供的订单信息，<strong>包括地址、费用金额并自动收集订单的交易状态，我们在您使用我们的服务过程中收集上述信息并向您展示，是基于大方租车为您提供在线交易、客诉服务以及依照平台规则处理用户纠纷所必须；</strong>我们收集上述信息以核实您是否按约支付费用，并按照平台规则处理用户纠纷。<br/>
      3. <strong>拨打电话：您通过大方租车在线下单后，与门店沟通车辆位置时需拨打门店电话，拨打电话我们需要获取您的拨打电话权限。</strong><br/>
      4. <strong>支付信息：您在大方租车平台进行交易支付时， 如果您使用第三方支付功能，</strong>
      大方租车除获取您的支付工具及订单支付状态外不会获取其他个人信息。大方租车将记录您的<strong>支付记录、银行卡号/第三方支付账号</strong>。大方租车收集上述信息以确认用户是否按约支付费用、订单是否收费异常，维护平台交易秩序，并按照平台规则处理用户纠纷。<br/>
      5.
      <strong>评价信息：</strong
      >在大方租车在线交易完成后，您可针对此次交易进行评价，大方租车将收集并展示您主动发布的评价以及发布的其他内容。请您<strong>谨慎填写避免造成个人敏感信息泄露</strong>，您未主动评价时系统将默认好评。<br/>
    </div>

    <div class="item">
      <h3>（三）客户服务及争议处理</h3>
      当您需要我们提供客户服务时，我们的客服（包括呼叫中心及在线客服）会使用<strong>您的相关信息，账户信息和订单信息</strong>。<br/>
      为保证您的账户安全，我们的呼叫中心客服和在线客服会使用您的账户信息对您的身份进行核验。待您的身份核验后，我们将会查询您的<strong>订单信息</strong>。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更联系人或联系电话。<br/>
      为保障您的合法权益，保证我们的客户服务合法合规，并持续改进我们的服务能力，我们会对<strong>您与客服沟通的过程进行文字留存，该留存信息仅会在法律所允许的期限和范围内予以留存和处理，并仅在基于您的维权需要、政府部门及司法部门的调查指令需要提供时，我们会进行必要披露。</strong><br/>
      为了提供服务及改进服务质量的合理需要，我们还可能使用的您的<strong>其他信息，包括您与客服联系时您提供的相关信息</strong>。
    </div>

    <div class="item">
      <h3>（四）您可选择是否授权我们收集和使用您的个人信息的情形</h3>
      除上述基本业务功能我们会收集和使用您的个人信息以外，我们的产品和服务还包括一些扩展业务功能，我们可能会在您使用扩展业务功能时收集和使用您的个人信息，如果您不提供这些个人信息，您依然可以实现租车服务的在线交易，但您可能将无法使用这些扩展业务功能：<br/>
      <strong>1、基于设备权限开启的权限功能</strong><br/>
      （1）<strong>基于精准位置信息的功能：</strong>我们会收集您的位置信息（我们仅收集您当时所处的<strong>地理位置</strong>，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点，自动为您展示您所在区域的附近门店。您可以授权提供您的位置信息，以便您基于所在地点位置选车。<br/>
      （2）<strong>基于大概位置功能：</strong>GPS未开启，会根据<strong>WIFI、数据网络</strong>获取大概位置来展示您所在大概区域的门店。<br/>
      （3）<strong>基于拨打电话号码的功能：</strong>您可以直接使用<strong>拨打手机号码</strong>来进行与门店沟通。在此功能中我们需要您开放拨打号码权限。<br/>
      <!-- （4）<strong>修改/删除/读取SD卡中的内容：基于上传您的照片来实现用户头像、身份信息采集、驾驶证信息采集以及评价等功能时，检测图像将图像缓存于SD卡中。</strong><br/> -->
      （4）<strong>基于摄像头（相机）的功能：</strong>您可以授权大方租车访问您的摄像头（相机）进行拍照，我们会识别<strong>您的照片来完成用户头像、身份信息采集、驾驶证信息采集</strong>。<br/>
      （5）<strong>基于相册（图片库）的功能：</strong>您可以授权大方租车访问您的相册并在大方租车上传<strong>您的照片来实现用户头像、身份信息采集、驾驶证信息采集以及评价</strong>等功能，我们会使用您所上传的照片来识别您的信息或使用包含您所上传图片的评价等。<br/>
      （6）<strong>基于剪切板的扩展功能：在您分享或接收被分享的信息、参加活动等情形下，我们需要访问您的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。</strong><br/>
      <!-- （8）<strong>基于访问应用列表权限的功能：</strong>在您通过大方租车点击使用第三方导航地图、第三方支付软件或向第三方软件（例如微信）分享信息时，我们会访问您的应用列表来判断您是否安装了前述特定软件，我们并不会收集您的全部应用列表信息，仅判断您是否安装了前述特定软件并获得判断结果用于支持您向第三方的跳转。<br/> -->
      <!-- （9）<strong>读取手机状态和身份：</strong>拨打手机号码来进行与门店沟通，我们需要获取您的手机状态和身份，以便知晓手机是否可以正常拨号，其他个人信息数据，我们不会收集。<br/> -->
      <!-- （10）<strong
    >基于通讯录的扩展功能：您可以授权我们获取您的通讯录权限、读取您的通讯录信息以帮助您快速录入紧急联系人姓名与手机号码，当然，如果您拒绝也可以通过手动输入的方式完成前述信息填写。</strong
    ><br/> -->
      （7）<strong>基于关联启动的扩展说明：</strong>如果您使用的是华为手机或其他我们在第三方应用商店投放广告的手机品牌，当您首次启动大方租车APP时，我们将自动关联启动您手机应用商店APP，以实现应用商店广告归因之目的。<br/>
      上述扩展功能可能需要您在您的设备中向我们开启您的相应权限，以实现这些功能所涉及的信息的收集和使用。您可以决定将这些权限随时开启或关闭（我们可指引您在您的设备系统中完成设置，上述部分权限/功能可能因您使用的手机系统差异或系统权限本身设置导致无法自行开关）。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。<br/>
      <strong>2、开具发票</strong><br/>
      当您使用大方租车服务需要取得发票时，大方租车门店为您提供发票。<br/>
      <strong>3、开展数据分析、不断改善产品和服务</strong><br/>
      为开展数据分析和更好改善大方租车服务，
      我们可能将业务时收集的个人信息用于统计分析和改进运营，例如通过您所在的位置、浏览和搜索信息等消费记录、地址偏好等进行统计分析，从而改进我们的产品、服务或营销计划；又如为改进我们系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告等。<br/>
      <strong>4、对第三方责任的声明</strong><br/>
      请您注意，您可能通过大方租车跳转功能访问第三方网站经营者、通过大方租车接入第三方服务（如有），以上第三方可能有自己的隐私权保护政策。当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会获取、使用您的个人信息，该等获取、使用不受大方租车的控制及本政策的约束。大方租车会尽商业上的合理努力去要求这些第三方对您的个人信息采取保护措施，但大方租车无法保证这些第三方一定会按照大方租车的要求采取保护措施，请您与这些第三方直接联系以获得关于他们的隐私权政策的详细情况。如您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。<br/>
      <strong>5、设备权限调用</strong><br/>
      大方租车可能会基于某些需要的具体应用场景调用您的一些对应的必要设备权限，并在调用前向您弹窗询问。<br/>
      您可以在设备的设置中选择关闭部分或者全部权限，这可能导致对于的业务功能无法实现或者无法达成预期目的。<br/>
      <strong>6、其他服务收集、使用、提供信息</strong><br/>
      如您选择使用我们提供的其他服务，基于该服务我们需要收集您的信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息。如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。<br/>
      <strong>7、其他用途</strong><br/>
      我们将您的个人信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的您的个人信息用于其他目的时，会单独征求您的授权同意。<br/>
      <strong>请注意：</strong
      >无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将无法与任何特定个人建立联系的数据与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
    </div>

    <div class="item">
      <h2>二、我们如何使用 Cookie 和同类技术</h2>
      <h3>（一）Cookies的使用</h3>
      1.为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies
      是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的偏好或您浏览历史等数据进而为您提供偏好设置、帮助您优化对广告的选择与互动、
      帮助判断您的登录状态以及账户或数据安全。<br/>
      2.我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有
      Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
      Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问大方租车网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
    </div>

    <div class="item">
      <h2>三、我们如何存储和保护您的个人信息</h2>
      <h3>1、信息保存期限</h3>
      （1）在用户使用大方租车服务期间，大方租车会持续保护用户的个人信息。<br/>
      （2）大方租车将按照法律、法规规定的为提供我们的服务之目的所必须的最短期间内保存您的个人信息，但您要求删除个人信息或法律法规另有规定的除外，当您的个人信息超出上述保存期限，
      大方租车将根据法律法规的要求删除您的个人信息或作匿名化处理。<br/>
      （3）为配合人民检察院、公安机关、国家安全机关对用户使用大方租车服务过程中产生的犯罪行为（包括涉嫌犯罪行为）的侦查，更好地保护其他用户的财产安全，当用户删除个人信息时，
      大方租车将在法律法规规定的保存期限内，加密隔离存档用户个人信息。<br/>
      （4）如您使用大方租车服务的过程中，存在严重违反法律法规、平台协议、平台政策或规则等情形，您的违法、违约记录及相应的平台信用记录、个人信息，将被永久保存。<br/>
      （5）大方租车与您另行签署的专项/具体的隐私协议或就某类信息的保存期限作做特殊约定的，从其约定。
    </div>

    <div class="item">
      <h3>2、信息存放地域</h3>
      我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行了法律规定的义务后，向境外实体提供您的个人信息：<br/>
      <strong>（1）适用的法律有明确规定；</strong><br/>
      <strong>（2）获得您的明确授权。</strong><br/>
      <strong>针对以上情形，我们会通过协议等形式确保以不低于本政策规定的程度保护您的个人信息。</strong>
    </div>

    <div class="item">
      <h3>3、安全保护措施</h3>
      （1）我们仅为实现本政策所述目的保留您的个人信息。<br/>
      （2）我们会采用符合业界标准的安全防护措施，通过建立数据全生命周期的安全管理规范和相应的技术管控措施并使用相应的安全技术和管理程序来保护您的个人数据，在任何时候尽力做到使您的个人信息不被泄露
      、毁损、丢失、不当使用、未经授权阅览或披露。<br/>
      （3）我们采取以下安全防护措施保护您的个人信息：<br/>
      1. 建立针对个人数据安全的纵深防御体系，数据从创建、存储、使用、传输、归档、销毁各环节上均采用管理与技术的双重控制措施，避免集中性的数据操作风险。<br/>
      2. 使用加密传输协议，保障数据传输安全。<br/>
      3. 严格控制数据访问权限，设立完善的敏感数据访问权限申请、审批制度。<br/>
      4. 建立数据安全监控和安全审计，进行全面数据安全控制。<br/>
      <strong>（4）我们同时采取其他安全措施保护您的个人信息：</strong><br/>
      1. 与全体员工签署保密协议，并严格按照工作职责分配数据访问权限。<br/>
      2. 定期开展面向全体员工的信息安全教育及培训。
    </div>

    <div class="item">
      <h3>4、安全事件处置</h3>
      （1）为应对个人信息泄露、毁损、丢失等可能出现的安全风险，已经在公司范围内颁布多项制度，明确了安全事故、安全漏洞的分类分级标准，以及针对上述安全事故和漏洞的内部处理流程和补救措施。<br/>
      （2）一旦发生安全事件，大方租车将及时向您告知事件基本情况和风险，大方租车已经采取或将要采取的措施、您如何自行降低风险的建议等。<br/>
      （3）我们将及时以推送通知、信函或电话等方式将安全事件情况通知受影响的用户。当难以逐一通知用户时，大方租车将通过发布平台公告的方式发布警示信息。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
    </div>

    <div class="item">
      <h3>5、停止运营</h3>
      （1）如大方租车停止运营，大方租车将至少提前30日在大方租车平台发布公告，并及时停止收集个人信息。<br/>
      （2）停止运营后，大方租车将停止对个人信息的商业化使用，并在满足法律法规规定的最短保存期后，对收集的个人信息进行匿名化处理。
    </div>

    <div class="item">
      <h3>6、免责条款</h3>
      （1）您同意并理解，即便竭尽所能加强安全防护措施，由于黑客攻击、技术限制、可能存在的各种恶意手段及/或其他因大方租车可控范围外的因素，大方租车所获得及保存的您的个人信息有可能在未经您许可的情况下被其他第三方获得，
      在这种情况下，<span>除非大方租车故意泄露您的该等信息，您不应当追究大方租车的责任。</span><br/>
      （2）在使用大方租车进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，
      否则对因此而造成的您的个人信息的泄露和损失，大方租车不承担任何责任。如您发现自己的个人信息泄密，尤其是账户及/或其密码发生泄露，请您立即联络大方租车客服（在线客服/客服热线<strong>4006668818</strong>），
      以便大方租车采取相应措施。<br/>
      （3）我们将根据法律法规规定及本政策约定对您的个人信息予以保密，但下列情形除外：<br/>
      1． 法律、法规、规章及其他规范性文件另有规定；<br/>
      2. 政府机关、司法机关及监管部门提出要求；<br/>
      3. 相关信息已成为公开信息；<br/>
      4. 您同意无须再严格保密；<br/>
      5. 本政策另有约定；<br/>
      6. 其他合法情形。
    </div>

    <div class="item">
      <h2>四、我们如何共享、转让、公开披露您的个人信息</h2>
      <h3>1、共享</h3>
      一、除以下情形外和本政策另有约定外，未经您同意，大方租车不得与任何第三方分享您的个人信息：<br/>
      （1） 实现本政策第1条所述为实现大方租车基本业务功能必须收集的信息所述目的， 只有共享您的个人信息，才能提供您所需要的服务；<br/>
      （2）处理您与他人的纠纷或争议（基于法定情形下：根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求）；<br/>
      （3）为了判断您的账户或交易是否安全；<br/>
      （4）为实现基本业务功能，大方租车可能将您的个人信息与大方租车的关联公司、技术服务提供商、第三方支付机构、实名签名认证机构及其他第三方服务供应商、承包商及代理商共享（例如代表大方租车发出推送通知的通讯服务提供商、为大方租车提供位置数据的地图服务供应商）；<br/>
      （5）根据法律规定、行政监管、刑事侦查机关为调查犯罪依法定程序调取的必要个人信息或行政机关、司机机构依法定程序调取的必要个人信息；<br/>
      （6）为遵守适用的法律法规、维护社会公共利益，或保护大方租车、大方租车的用户、雇员的人身、财产安全或其他合法权益所必须使用的合理用途；<br/>
      （7）您出现违反有关法律规定或者《大方租车用户服务协议》或平台规则的情况，需要向第三方披露您的个人信息；<br/>
      （8）履行大方租车在《大方租车用户服务协议》或本政策中的义务和行使大方租车的权利，以及其他大方租车根据法律规定、《大方租车用户服务协议》及/或大方租车平台的其他规则认为有必要披露的情形。<br/>
      二、如您在使用大方租车第三方提供的服务或大方租车与其他第三方进行联合推广活动时，大方租车可能根据第三方要求收集您的相关信息提供给服务商、第三方商家等我们的合作伙伴，或共享活动过程中产生的、为完成活动所必要的个人信息。我们会在您接受服务前明确告知所涉及个人信息的目的、类型以及披露对象等，并征得您的明示同意。<br/>
      三、我们可能将个人信息统计数据、
      脱敏数据及/或加密数据提供给大方租车的合作方，用于进行产品测试、建造风控模型、基础设计、开发、推广全新的产品及服务、或用于改善大方租车现有服务；<br/>
      四、就您在大方租车上确认、同意的协议、规则、政策、文档等（统称“协议文件”），大方租车可能会将协议文件置于实名签约平台以数据电文形式在线签署并储存，并将您的个人信息（姓名、证件号、手机号及其他身份认证信息）报送给实名签约平台用于实名签名认证并生成数字证书，大方租车合作的实名签约平台将托管并调用您的数字证书代您签署协议文件。大方租车可能将协议文件内容发送到实名签约平台生成签约文本。
      协议文件使用的实名签约平台为可合法有效提供实名签约服务的实名签约平台。
      大方租车将向实名签约平台调取协议文件、您的签约信息、您的身份认证信息及与证明协议文件有效性、您的人脸签名有效性相关的其他信息。
      如您不同意前述实名签约相关事项， 可能无法与大方租车及/或第三方达成交易。<br/>
      五、为了保障大方租车平台业务功能的实现，我们可能会通过应用程序接口（API）、软件工具开发包（SDK）与第三方进行必要的数据共享，
          <strong>不同版本的第三方SDK会有所不同，我们会尽到审慎义务，努力保障数据安全。<!-- 我们对接入的相关第三方SDK已在第三方SDK目录中列明，您可以点击前述超链接查看。--></strong><br/>
<!--      关于第三方插件管理<br/>为了给您提供更专业、安全的核心业务功能和附加业务功能，我们的产品中会接入第三方插件产品（包括在我们的网页或应用程序中部署统计分析工具、软件开发工具包SDK、调用地图API接口）。<br/>-->
      六、除本政策约定的大方租车将您的个人信息提供给第三方的情形以外，如基于其他情况大方租车需将您的个人信息提供给第三方，大方租车将按照法律法规的要求以确认协议、具体场景下的文案确认动作等形式另行征得您的同意。<br/>
      七、除本政策另有约定外，非经法定程序或获得您的同意，大方租车不<span>得</span>将您的个人信息提供给任何第三方机构或个人。对大方租车与之共享个人信息的公司、组织和个人，大方租车会努力与之签署保密协议，
      要求其按照大方租车的说明、本政策及其他任何相关的保密和安全措施来处理个人信息。
    </div>
    <div class="item">
      <h3>2、转让</h3>
      随着大方租车业务的持续发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易等变更，您同意授权大方租车有权将您的个人信息作为此类交易的一部分而被转移。如涉及个人信息的转让，
      我们会要求受让您个人信息的公司、组织继续接受本隐私政策的约束，否则，我们将要求该公司、组织重新征求您的授权同意。
    </div>

    <div class="item">
      <h3>3、公开披露</h3>
      我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才可能公开披露您的个人信息：<br/>
      （1）根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br/>
      （2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，
      当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
    </div>

    <div class="item">
      <h3>4、共享、转让、公开披露个人信息时事先征得授权同意的例外</h3>
      <strong>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</strong><br/>
      （1）与大方租车履行法律法规规定的义务相关的；<br/>
      （2）与国家安全、国防安全有关的；<br/>
      （3）与公共安全、公共卫生、重大公共利益有关的；<br/>
      （4）与犯罪侦查、起诉、审判和判决执行等有关的；<br/>
      （5）出于维护您或其他个人的生命、 财产等重大合法权益但又很难得到本人同意的；<br/>
      （6）其他维护公共利益的情形，例如您的信用评价信息需要被公开共享；<br/>
      （7） 您自行向社会公众公开的个人信息；<br/>
      （8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br/>
      （9）根据法律规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。
    </div>

    <div class="item">
      <h3></h3>
      5、如发生收购、兼并、重组等变更，大方租车会要求变更后的主体依然遵守本隐私政策的约定，履行责任和义务。如变更后的主体需变更个人信息使用目的的，我们会要求其事先获得您的明示同意。在之前的收购、兼并、
      重组活动中，对于被收购、被兼并、被重组对象管理的数据（包括用户数据）均采用与大方租车自有数据相同的标准和要求进行处理和保护。
    </div>

    <div class="item">
      <h3></h3>
      6、大方租车平台的某些产品/服务由第三方机构或个人提供。对大方租车与之委托处理个人信息的公司、组织和个人，我们会努力与之签署保密协议，要求他们按照大方租车的说明、本政策及其他任何相关的保密和安全措施来处理个人信息。<br/>
      <strong>请注意：</strong>您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您的交易信息，以及您在评价时选择上传包含个人信息的文字，图片或视频等各种形式的信息。
      请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。
    </div>

    <div class="item">
      <h3>五、<strong>第三方SDK名称、收集个人信息类型、使用目的</strong></h3>
      <strong>iOS/Android系统产品中存在的第三方插件披露如下：</strong><br/>
      <ul class="tabel">
        <li>
          <div>第三方SDK</div>
          <div>收集个人信息类型</div>
          <div>使用目的</div>
        </li>
        <li>
          <div>华为 update SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>系统更新检测</div>
        </li>
        <li>
          <div>华为消息推送 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>在友盟推送不支持的情况下，提供构筑良好的用户关系，提升用户的感知度和活跃度的通道</div>
        </li>
        <li>
          <div>华为 AppGallery Connect core SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>提供分钟级性能监控能力</div>
        </li>
        <li>
          <div>中国移动号码认证 SDK</div>
          <div><strong>手机号码</strong></div>
          <div>提供账号一键注册登录功能</div>
        </li>
        <li>
          <div>阿里移动热修复 SDK</div>
          <div><strong>APP启动和点击行为</strong></div>
          <div>APP启动和点击行为、进行性能监控，排查崩溃原因</div>
        </li>
        <li>
          <div>阿里云移动数据分析 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>终端统计分析服务，分析产品在不同终端设备上的表现。</div>
        </li>
        <li>
          <div>阿里设备标识 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>应用性能监测服务，帮助提升应用质量，提供基础反作弊能力。</div>
        </li>
        <li>
          <div>阿里云一键登录</div>
          <div><strong>手机号码、设备信息（SIM卡IMSI信息）、MAC地址、网络信息（IP地址）、OAID</strong></div>
          <div>用于支持app登录时使用手机号码一键登录</div>
        </li>
        <li>
          <div>淘宝通道服务 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>网络调度服务</div>
        </li>
        <li>
          <div>友盟消息推送SDK</div>
          <div><strong>设备信息，应用信息，设备参数及系统信息，地理位置信息</strong></div>
          <div>提供消息推送功能，并分析数据提升用户体验</div>
        </li>
        <li>
          <div>友盟移动统计 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储、ICCID</strong></div>
          <div>终端统计分析服务，分析产品在不同终端设备上的表现，通过地理位置校准报表数据准确性，提供基础反作弊能力。</div>
        </li>
        <li>
          <div>腾讯 Bugly SDK</div>
          <div><strong>日志信息（包括：第三方开发者自定义日志、Logcat 日志以及 APP 崩溃堆栈信息）、设备 ID（包括：androidid 以及idfv）、联网信息、系统名称、系统版本以及国家码。</strong></div>
          <div>性能监控并及时解决平台问题</div>
        </li>
        <li>
          <div>魅族Flyme推送SDK</div>
          <div><strong>设备信息，应用信息，设备参数及系统信息，地理位置信息</strong></div>
          <div>提供消息推送功能</div>
        </li>
        <li>
          <div>Ping++标准版SDK、淘宝SDK、腾讯SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div><strong>用户登录微信和支付过程中的安全风控，完成交易费用支付</strong></div>
        </li>
        <li>
          <div>岳鹰全景监控SDK</div>
          <div><strong>APP启动和点击行为</strong></div>
          <div>APP启动和点击行为</div>
        </li>
        <li>
          <div>百度人脸识别、身份证驾驶证识别 SDK</div>
          <div><strong>人像信息、身份信息	、驾驶证信息</strong></div>
          <div><strong>人脸检测与分析、五官定位、人脸比对、人脸搜索、人脸验证、人员库管理、人脸静态活体检测等一系列人脸识别类服务；身份证、驾照文字识别</strong></div>
        </li>
        <li>
          <div>高德定位 SDK</div>
          <div><strong>获取连接WIFI信息、位置信息（GNSS信息、WIFI地址及信号强度信息、基站ID数据信息、传感器信息、手机信号强度信息）</strong></div>
          <div>提供地图与定位服务</div>
        </li>
        <li>
          <div>支付宝分享SDK</div>
          <div><strong>设备信息、系统信息、应用版本、Mac地址、IMEI</strong></div>
          <div>提供分享功能服务</div>
        </li>
        <li>
          <div>支付宝支付 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div><strong>用户登录支付宝账户和支付过程中的安全风控，以完成交易费用支付，以及芝麻免押服务（如涉及）</strong></div>
        </li>
        <li>
          <div>微信分享SDK</div>
          <div><strong>设备信息、系统信息、应用版本、Mac地址、IMEI</strong></div>
          <div>提供分享功能服务</div>
        </li>
        <li>
          <div>微信支付 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div><strong>用户登录微信和支付过程中的安全风控，完成交易费用支付</strong></div>
        </li>
        <li>
          <div>神策 SDK</div>
          <div><strong>设备信息、唯一设备识别码、MAC地址、网络信息、位置信息、设备存储</strong></div>
          <div>基础数据收集，驱动业务决策分析，分析数据提高用户体验</div>
        </li>
        <li>
          <div>Android Support Library Compat</div>
          <div>无</div>
          <div>安卓兼容控件</div>
        </li>
        <li>
          <div>AndroidAutoSize</div>
          <div>无</div>
          <div>适配各种手机屏幕尺寸控件</div>
        </li>
        <li>
          <div>Picasso</div>
          <div>无</div>
          <div>图片加载控件</div>
        </li>
        <li>
          <div>EasyPermissionsSDK</div>
          <div>无</div>
          <div>快速获取手机权限控件</div>
        </li>
      </ul>
      <br/>
      以上插件会根据产品功能收集您的个人信息，我们仅会在您授权同意开通相关功能或在您主动使用相关功能我们给予充分提示时，才会将您的对应个人信息接口授权给上述第三方插件。<br/>
      <strong>请注意：如果您想进一步了解第三方SDK情况，请以第三方公示的官方说明为准。</strong><br/>
      <!-- 点击查看<strong @click="openUrl">《号码认证服务隐私政策》</strong>详情<br/> -->
    </div>
    <div class="item">
      <h3>六、<strong>自启动和关联启动说明</strong></h3>
      （1）为确保本应用处于关闭或者后台运行状态下可以正常接收客户端推送的广播消息，本应用须使用（自启动）能力，将存在一定频率通过系统发送广播唤醒本应用自启动行为，是因实现功能及服务所必要的。<br/>      
      （2）为了带给您更好的体验，应用引入了中国移动号码认证 SDK（com.taobao.accs，com.taobao.accs），关联了自启动功能，目的是当您准备一键登录时可以查看到可以“一键登录”的手机号，确认后登录。<br/>
      （3）为确保客户签署合同是本人确认，应用引入了<strong>百度人脸识别SDK(com.baidu.liantian)</strong>,关联了自启动功能，目的是当你第一次准备署电子合同时进行人脸识别<br/>
      （4）在您未同意用户协议和隐私政策前，若您点击查看用户协议和隐私政策，为防止第三方SDK收集您的个人信息，我们会通过启动系统浏览器来供您查看用户协议和隐私政策。<br/>
    </div>
    <div class="item">
      <h2>七、您的权利</h2>
      <h3>1、访问、更正您的个人信息</h3>
      您可以通过以下方式管理您的信息：<br/>
      （1）账户信息：您可以通过您在大方租车移动端的[“我的”-“设置”-“账号设置”] <strong>页面访问、您提供的本人手机号码。</strong><br/>
      （2）身份认证：您可以通过您在大方租车移动端的[“我的”-“设置”-“账号设置”]
      页面进行您的身份认证；若您需更正您的身份认证信息，您可联系大方租车客服（在线客服/拨打客服热线（<strong>4006668818</strong>）申请更正。<br/>
      （3）用户资料：您可以通过您在大方租车移动端中的[“用户头像”-“编辑资料”中进行相关资料的<strong>填报、编辑与访问。</strong><br/>
      （4）订单信息：您可以在大方租车移动端的【“订单”】页面访问<strong>您的订单、及交易状态。</strong>
    </div>

    <div class="item">
      <h3>2、撤回同意</h3>
      大方租车将通过以下方式保障您撤回同意的权利：<br/>
      （1）大方租车发送的商业广告短信中，会向您说明具体退订方式，您可以按照短信中说明的退订方式撤回同意。<br/>
      （2）您可通过“大方租车”移动端所属设备的权限设置功能改变您授权我们继续收集个人信息的范围或关闭相应权限（包括<strong>位置、通讯录、相机、照片、通知</strong>等），撤回对大方租车获取您个人信息的授权。<br/>
      （3）您还可以通过<strong>解除银行卡绑定、删除信息</strong>等方式撤回部分授权。<br/>
      （4）当您撤回同意或授权后，可能导致大方租车无法为您继续提供撤回授权部分对应的服务。当您撤回同意或授权，不影响撤回前基干您的同意开展的个人信息收集，您也可以通过设备的设置功能，
      关闭相应权限（包括<strong>位置、通讯录、相机、照片、通知</strong>等），撤回对大方租车获取您个人信息的授权。
    </div>

    <div class="item">
      <h3>3、注销账户</h3>
      您可以在我们的产品中直接申请注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，删除您的个人信息。<br/>
      注销路径：在APP中“我的-设置-注销账号”注销账号，或联系大方租车客服注销账号
    </div>

    <div class="item">
      <h3>4、响应您的上述请求</h3>
      （1）如您无法通过上述方式访问、更正、删除个人信息、撤回同意，您可以随时联系大方租车客服（在线客服/客服热线<strong>4006668818</strong>）。大方租车客服可能需要验证您的身份，并在验证您的身份后15日内作出答复或合理解释。<br/>
      （2）对于您合理的请求，我们原则上不收取费用，但对多次重复超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如：需要开发新系统或从根本上改变现行惯例）、
      给他人合法权益带来风险或者非常不切实际（例如：涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。<br/>
      （3）在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br/>
      1.与国家安全、国防安全直接相关的；<br/>
      2.与公共安全、公共卫生，重大公共利益直接相关的；<br/>
      3.与犯罪侦查、起诉、审判和判决执行等直接相关的；<br/>
      4.有充分证据表明您存在主观恶意或滥用权利的；<br/>
      5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br/>
      6.涉及商业秘密的。
    </div>

    <div class="item">
      <h2>八、本政策的更新</h2>
      （1）如大方租车发生以下变化，大方租车将及时对本政策进行相应的修订：<br/>
      （2）我们的业务功能发生变更。<br/>
      （3）用户个人信息保存地域发生变更。<br/>
      （4）用户个人信息的收集、使用规则发生变更。<br/>
      （5）我们的联络方式及投诉渠道发生变更。<br/>
      （6）发生其他可能影响用户个人信息安全或影响用户隐私权利的变更等。<br/>
      （7）如本政策发生修订，大方租车会在大方租车平台发布最新版本，并以推送通知的方式告知您，以便您及时了解最新版本的本政策。若您在本政策的内容发生修改、变更后，继续使用大方租车服务的，
      视为您已阅读、了解并同意最新修订的本政策内容。
    </div>

    <div class="item">
      <h2>九、如何联系我们</h2>
      如果您对于我们的个人信息处理行为存在任何投诉举报需求，您可以通过大方租车平台上提供的联系方式、联系客服（在线客服/客服热线<strong>4006668818</strong>）等方式与我们联系并作充分描述，
      <strong>我们将在验证您身份的15日内答复您的请求并尽力解决。</strong>如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向大方租车住所地有管辖权的法院提起诉讼。
    </div>

    <div class="item">
      <h3></h3>
      版本V8.0.0  2024年4月29日<br/>
      版本V7.0.0  2023年11月29日<br/>
      版本V6.0.0  2023年6月19日<br/>
      版本V5.0.0  2023年5月26日<br/>
      版本V4.0.0  2021年9月18日<br/>
      版本V3.0.0  2021年8月31日<br/>
      版本V2.0.0  2021年7月15日<br/>
      版本V1.0.0  2021年4月28日<br/>
    </div>
  </div>
</template>
<script>
  export default {
    name: "privacy",
    data() {
      return {
        isShow: false,
      };
    },
    props: [],
    methods: {
      showCont() {
        this.isShow = true;
      },
      hideCont() {
        this.isShow = false;
      },
    },
  };
</script>
<style lang="scss" scoped type="text/scss">
  .dfAgreement {
    font-size: 28px;
    line-height: 42px;
    color: #434343;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .title {
      line-height: 100px;
      text-align: center;
      font-size: 36px;

      h1 {
        font-size: 100%;
        font-weight: bold;
      }
    }

    .upDataInfo {
      margin-top: 24px;
    }

    .item {
      .tabel {
        width: 100%;
        border: 1px solid #222;
        border-bottom: 0;
        font-size: 20px;
        overflow: hidden;
        li {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #222;
          div {
            word-wrap: break-word;
            padding-left: 2px;
            padding-right: 2px;
            padding-bottom: 10000px;
            margin-bottom: -10000px;
            position: relative;
            height: 100%;
            overflow: hidden;
            &:nth-of-type(1) { width: 25%;text-align: center; }
            &:nth-of-type(2) { width: 45%; border-left: 1px solid #222; }
            &:nth-of-type(3) { width: 30%; border-left: 1px solid #222; }
          }
        }
      }
      h2 {
        margin-top: 25px;
        font-weight: bold;
        font-size: 32px;
      }

      h3 {
        margin-top: 20px;
        font-weight: bold;
        font-size: 30px;
      }

      h4 {
        margin-top: 15px;
        font-size: 100%;
        font-weight: normal;
      }
    }
  }
</style>
